import type { PetRule } from "./petRule";

/**
 * Muster (Pets v2, docs/PETS.md): the fortress's troops come out faster — the spawn interval is cut by the run's
 * `spawnCutPercent`, rounded down to whole ticks, never below one tick. Set once when the run is built (LevelSim). A run
 * without a pet never changes here, so it plays and hashes as it always did. The pet's other abilities run in
 * sim/petSystem.ts.
 */
export function petSpawnInterval(intervalTicks: number, pet: PetRule | null): number {
  if (pet === null || pet.spawnCutPercent <= 0) return intervalTicks;
  return Math.max(1, intervalTicks - Math.floor((intervalTicks * pet.spawnCutPercent) / 100));
}
